import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Fisioterapia per Anziani",
  "Riabilitazione Post-Operatoria",
  "Ritorno alle Attività Quotidiane",
  "Riabilitazione Sportiva",
  "Trattamento dei Dolori Cronici",
  "Recupero Post-Infortunio",
  "Trattamenti in Studio a Torino",
  "Disallettamento",
  "Prevenzione delle Cadute",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-pine/10 bg-cream py-5 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif italic text-xl lg:text-2xl text-pine whitespace-nowrap">{item}</span>
            <Asterisk size={20} strokeWidth={1.5} className="mx-8 text-terracotta shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
